import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, clearError } from '../store/authSlice';
import { useNavigate, Link } from 'react-router-dom';

const STORAGE_KEY = 'finema_recent_emails';

function getRecentEmails() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
  catch { return []; }
}

function saveRecentEmail(email) {
  const list = getRecentEmails().filter(e => e !== email);
  list.unshift(email);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 2)));
}

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const recentEmails = getRecentEmails();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) navigate('/explore');
  }, [user, navigate]);

  useEffect(() => {
    return () => dispatch(clearError());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    saveRecentEmail(email);
    dispatch(login({ email, password }));
  };

  return (
    <div className="auth-page">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Log In</h2>
        {error && <div className="error-msg">{error}</div>}
        {error && error.includes('not verified') && (
          <p style={{ fontSize: 13, color: '#888', textAlign: 'center', margin: '0 0 8px' }}>
            <Link to="/verify-email-sent" state={{ email }} style={{ color: '#C8963E' }}>
              Resend verification email
            </Link>
          </p>
        )}
        <input type="email" name="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} list="recent-emails" autoComplete="off" required />
        <datalist id="recent-emails">
          {recentEmails.map(e => <option key={e} value={e} />)}
        </datalist>
        <input type="password" name="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        <button type="submit" disabled={loading} className="btn btn-primary">
          {loading ? 'Logging in...' : 'Log In'}
        </button>
        <p className="auth-link">Don't have an account? <Link to="/register">Sign up</Link></p>
      </form>
    </div>
  );
}
